import * as React from 'react';
import * as classnames from 'classnames';
import {
    OptionBoxWrapper,
    OptionGroupElement
} from '../../../../common/optionBox';
import Toggle from '../../../../common/Toggle';

const OptionCardImage = (props) => {
    const labelTitle = props.isTypeScale ? 'Scale' : 'Option';
    const { option, optionError, index } = props;
    return (
        <React.Fragment>
            <div
                className={classnames('option-box--image-box', {
                    disabled: !props.editEnabled
                })}
                onClick={() => props.openMediaLibrary(index)}
            >
                {option.mediaURL ? (
                    <img src={option.mediaURL} />
                ) : (
                    <i className="nx nx-image-mb" />
                )}
                <span
                    // onClick={() => props.openMediaLibrary(index)}
                    className={classnames('nx-option-edit', {
                        disabled: !props.editEnabled
                    })}
                >
                    <i className="nx nx-edit"></i>
                </span>
            </div>

            <OptionBoxWrapper>
                {optionError.mediaURL ? (
                    <OptionGroupElement label="" error={optionError.mediaURL}>
                        <span />
                    </OptionGroupElement>
                ) : null}
                <OptionGroupElement
                    label={`${labelTitle} label`}
                    error={optionError.label}
                >
                    <input
                        type="text"
                        placeholder={`${labelTitle} label ${index + 1}`}
                        value={option.label}
                        onChange={(event) => props.handleChange(index, event)}
                        className="form-group__control"
                        name="label"
                        disabled={!props.editEnabled}
                        required
                    />
                </OptionGroupElement>
                <OptionGroupElement
                    label={`${labelTitle} value`}
                    error={optionError.value}
                >
                    <input
                        type="number"
                        placeholder={`${index + 1}`}
                        value={option.value}
                        onChange={(event) => props.handleChange(index, event)}
                        className="form-group__control"
                        name="value"
                        disabled={!props.editEnabled}
                        required
                        min="0"
                    />
                </OptionGroupElement>
                {props.showRandomize ? (
                    <OptionGroupElement label="Randomize">
                        <Toggle
                            onChange={(value) =>
                                props.handleToggleValueChange(
                                    index,
                                    'randomizeOption',
                                    value
                                )
                            }
                            disabled={!props.editEnabled}
                            checked={option.randomizeOption}
                        />
                    </OptionGroupElement>
                ) : null}
            </OptionBoxWrapper>
        </React.Fragment>
    );
};

export default OptionCardImage;
